//import $ from 'jquery';
//import makeTitle from 'gulp-cli/lib/shared/make-title';

//flickity all cell to the higher one
function setFlickitySliderHeightToMax(controlElement, flickityMainClass, productItem){
    function setSliderHeightToMax(slider) {
        let s = document.querySelectorAll(slider),
        maxHeight = 0;
        s.forEach((cell) => {
        cell.style.height = "";
        if (cell.offsetHeight > maxHeight) {
            maxHeight = cell.offsetHeight;
        }
        });
        s.forEach((cell) => {
        cell.style.height = maxHeight + "px";
        });
    }
    const index = document.querySelector(controlElement);
    if(index !== undefined && index !== null) {
        let count = 0;
        const myIntSlider = setInterval(() => {
        let slider = document.querySelector(flickityMainClass + ".flickity-enabled");
        if (slider != null && slider != "") {
            setSliderHeightToMax(flickityMainClass + ' ' + productItem); //flickity item
            clearInterval(myIntSlider);
        }
        if(count> 200) clearInterval(myIntSlider);
        count++;
        }, 50);
    }
}
setFlickitySliderHeightToMax('body.index', '.product-items.is-slider', '.product-item');
setFlickitySliderHeightToMax('body.product', '.product-items', '.product-item');
